export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "r-v3/js/grm-selfieSegmentationWorker-runner.8c277adb.worker.js");
}
